import URLConst from '../constants/URLConst';
import {fetchJSON, secureGET, securePOST, securePUT, secureDELETE, withQuery} from '../utilities/FetchHelper';

class RoomTypeBucketsService {

    getRoomTypesBuckets(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPE_BUCKETS
        url = url.replace("{hotelCode}", data["hotelCode"])

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
           return response
        }).catch((error) => {
           throw error
        })
    }

    putRoomTypesBuckets(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPE_BUCKETS
        url = url.replace("{hotelCode}", data["hotelCode"])
        delete data.hotelCode
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    postRoomTypesBuckets(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPE_BUCKETS
        url = url.replace("{hotelCode}", data["hotelCode"])
        delete data.hotelCode
        return fetchJSON(url, { ...securePOST(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    deleteRoomTypesBuckets(data) {

        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPE_BUCKETS
        url = url.replace("{hotelCode}", data["hotelCode"])
        url = url + "/" + data["name"]

        return fetchJSON(url, { ...secureDELETE(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RoomTypeBucketsService()